import {NgModel} from 'model/ngModel';

export const Vertical = NgModel.extend({
    _name: 'Vertical',
});
